import React, { useEffect, useState } from 'react';
import { codiceValido } from '../../lib/services/colataService';
import { generaSvgBarcode, FORMATO_PREDEFINITO } from '../../lib/colataBarcode';

// Codice a barre in SVG (vettoriale: nitido a qualsiasi risoluzione e in stampa).
// `formato`: per ora solo "code128" (il QR si aggiungerà come alternativa).
// La generazione dell'SVG (con JsBarcode, caricato solo quando serve) è in lib/colataBarcode.js.

export { generaSvgBarcode };

/** Stato di generazione del codice a barre: { svg, errore, caricamento } */
export const useBarcodeCodice = (codice, formato = FORMATO_PREDEFINITO) => {
  const [stato, setStato] = useState({ svg: null, errore: null, caricamento: true });

  useEffect(() => {
    let annullato = false;
    const valore = String(codice ?? '').trim();

    if (!valore) {
      setStato({ svg: null, errore: 'Codice mancante: impossibile generare il codice a barre.', caricamento: false });
      return undefined;
    }
    if (!codiceValido(valore)) {
      setStato({ svg: null, errore: 'Codice non valido (4-24 caratteri: lettere, numeri, trattino).', caricamento: false });
      return undefined;
    }

    setStato((precedente) => ({ ...precedente, caricamento: true, errore: null }));
    generaSvgBarcode(valore, formato)
      .then((svg) => {
        if (!annullato) setStato({ svg, errore: null, caricamento: false });
      })
      .catch(() => {
        if (!annullato) setStato({ svg: null, errore: 'Impossibile generare il codice a barre.', caricamento: false });
      });
    return () => { annullato = true; };
  }, [codice, formato]);

  return stato;
};

/**
 * Codice a barre (solo visualizzazione) su fondo bianco con il codice leggibile sotto.
 * La larghezza si imposta con className (es. "w-[130px]"); l'altezza segue le proporzioni.
 */
const BarcodeCodice = ({ valore, formato = FORMATO_PREDEFINITO, className = 'w-[130px]' }) => {
  const { svg, errore, caricamento } = useBarcodeCodice(valore, formato);

  if (errore) {
    return (
      <div className={`${className} rounded-lg border border-red-500/30 bg-red-500/5 px-2 py-1.5`}>
        <p className="text-[8px] font-black uppercase tracking-wider text-red-500 leading-tight">
          {valore ? 'Codice non valido' : 'Codice mancante'}
        </p>
      </div>
    );
  }

  return (
    <div
      className={`${className} bg-white rounded-lg p-1 border border-border/40 shadow-sm`}
      aria-label={`Codice a barre ${valore}`}
      role="img"
    >
      {caricamento || !svg ? (
        <div className="aspect-[2.3/1] w-full rounded bg-muted/20 animate-pulse" />
      ) : (
        <div className="[&>svg]:block [&>svg]:w-full [&>svg]:h-auto" dangerouslySetInnerHTML={{ __html: svg }} />
      )}
    </div>
  );
};

export default BarcodeCodice;
